export default {
  shared: {
    appVersion: "Versión de la app",
    brand: "Marca",
  },
  assignBeforePairing:
    "Asigne este dispositivo a una estructura antes de vincular un lector",
  deviceRevoked: "Dispositivo revocado",
  deviceReactivated: "Dispositivo reactivado",
  deviceShelved: "Dispositivo aparcado",
  deviceUnshelved: "Dispositivo de nuevo en uso",
  credentialsRegenerated: "Credenciales regeneradas",
  kioskAssigned: "Dispositivo asignado correctamente",
  readerUpdated: "Lector actualizado",
  deviceRenamed: "Nombre visible actualizado",
  deviceGoogleAccountUpdated: "Cuenta Google actualizada",
  deviceNotesUpdated: "Notas actualizadas",
  page: {
    kpiTotal: "Dispositivos activos",
    kpiTotalHint: "Sin contar los revocados",
    kpiOnline: "En línea",
    kpiOnlineHint: "Telemetría completa en las últimas 20 h",
    kpiIncomplete: "Configuración incompleta",
    kpiIncompleteHint: "Falta vinculación, lector o estructura",
    kpiShelved: "Aparcados",
    kpiShelvedHint: "Fuera de servicio",
    title: "Gestión de dispositivos",
    subtitle: "Gestione los dispositivos de las estructuras",
    newDevice: "Nuevo dispositivo",
    tabDevices: "Dispositivos",
    tabPresets: "Plantillas de dispositivo",
    searchPlaceholder: "Buscar por nombre, código, estructura u otro…",
    filterActiveLabel: "Activo",
    filterActiveAll: "Todos",
    filterActiveActive: "Activos",
    filterActiveInactive: "Inactivos",
    filterSetupLabel: "Configuración",
    filterSetupAll: "Todos",
    filterSetupComplete: "Completos",
    filterSetupIncomplete: "Incompletos",
    filterSetupRevoked: "Revocados",
    filterShelvedLabel: "Aparcamiento",
    filterShelvedAll: "Todos",
    filterShelvedInService: "En uso",
    filterShelvedOnly: "Aparcados",
    filterTelemetryLabel: "Estado de telemetría",
    filterTelemetryAll: "Todos",
    filterTelemetryGray: "Sin vincular",
    filterTelemetryGreen: "Completa",
    filterTelemetryYellow: "Incompleta",
    filterTelemetryRed: "Sin datos (> 20 h)",
    filterAppVersionAny: "Cualquiera",
    filterAppVersionCount: "{{count}} seleccionadas",
    filterIncompleteMissingLabel: "Detalle de configuración incompleta",
    filterIncompleteMissingAny: "Cualquiera",
    filterIncompleteMissingCount: "{{count}} seleccionados",
    filterMissingBinding: "Falta clave de software",
    filterMissingReader: "Falta lector",
    filterMissingStructure: "Falta estructura",
    telemetryTooltipGray: "Sin acceso o sin vincular",
    telemetryTooltipGreen: "Telemetría completa",
    telemetryTooltipYellow: "Telemetría incompleta",
    telemetryTooltipRed: "Sin telemetría (> 20 h)",
    setupBadgeIncomplete: "Incompleto",
    setupBadgeRevoked: "Revocado",
    setupBadgeIncompleteTooltipTitle: "Aún falta:",
    setupBadgeIncompleteTooltipDesc:
      "Este dispositivo no puede aceptar pagos hasta completar la configuración.",
    setupBadgeRevokedTooltip: "Este dispositivo ha sido revocado",
    setupMissingBinding: "Vinculación de clave de software",
    setupMissingBindingDesc:
      "La tablet debe iniciar sesión con su clave de software al menos una vez.",
    setupMissingPairing: "Vinculación del lector de pago",
    setupMissingPairingDesc:
      "Debe vincularse un lector de pago a esta tablet para procesar pagos con tarjeta.",
    setupMissingAssignment: "Asignación a estructura",
    setupMissingAssignmentDesc:
      "El dispositivo debe asignarse a una estructura de anfitrión.",
    colDevice: "Nombre visible",
    colSerial: "N/S",
    colGoogleAccount: "Cuenta Google",
    colFreekioskUnlock: "Desbloqueo FK",
    colReader: "Lector",
    colHouse: "Estructura",
    colLastTelemetry: "Última telemetría",
    colLastInteraction: "Última interacción",
    colInUse: "En uso",
    colActions: "Acciones",
    selectRow: "Seleccionar {{name}}",
    selectAllFiltered: "Seleccionar los {{count}} filtrados",
    exportCsv: "Exportar CSV",
    emptySearch: "No hay dispositivos que coincidan con la búsqueda.",
    emptyDefault: "No hay dispositivos. Cree el primero para empezar.",
    readerPair: "Vincular",
    readerUnpairTitle: "Desvincular lector",
    readerUnpairConfirm:
      "¿Desvincular este lector de la tablet? El emparejamiento con SumUp se conserva; los pagos permanecerán desactivados hasta que vuelvas a vincular.",
    readerUnpaired: "Lector desvinculado",
    houseOpenTitle: "Abrir estructura",
    houseRemoveTitle: "Quitar estructura del dispositivo",
    houseRemoveConfirm:
      "¿Quitar «{{name}}» de este dispositivo? Quedará sin asignar.",
    houseRemoved: "Estructura eliminada",
    assign: "Asignar",
    moreActionsTitle: "Más acciones",
    regenerateConfirm:
      "¿Regenerar contraseña de «{{name}}»? Las sesiones del tablet existentes dejarán de ser válidas.",
    credentialModalTitle: "Credenciales regeneradas",
    credentialModalDesc:
      "La contraseña se ha regenerado. Guarde estas credenciales ahora: la contraseña solo se muestra una vez.",
    statusPartial: "Parcialmente configurado",
    assignModalTitle: "Asignar dispositivo",
    assignModalIntro: "Asigne {{name}} a un anfitrión y una estructura.",
    selectHostStep: "1) Seleccionar anfitrión",
    selectHouseStep: "2) Seleccionar estructura",
    searchHostsPlaceholder: "Buscar anfitriones…",
    searchHousesPlaceholder: "Buscar estructuras…",
    searchHousesDisabledPlaceholder: "Primero elija un anfitrión…",
    noHostsFound: "No se encontraron anfitriones.",
    pickHostForHouses: "Elija un anfitrión para ver sus estructuras.",
    noHousesFound: "No se encontraron estructuras.",
    noAddressSet: "Sin dirección",
    assignedDevicesLabel: "Dispositivos asignados:",
    assignSubmit: "Asignar",
    otherInfoTitle: "Más datos del dispositivo",
    fieldDisplayName: "Nombre mostrado",
    fieldKioskCode: "Código de dispositivo",
    fieldSerialNumber: "Número de serie",
    fieldSoftwareId: "ID de software",
    fieldGoogleAccount: "Cuenta Google",
    fieldReaderId: "ID del lector",
    fieldDisplayInches: "Pulgadas de pantalla",
    fieldResolution: "Resolución",
    fieldAndroidVersion: "Versión de Android",
    valueAppVersionUnknown: "Desconocida",
    valueAppVersionLegacy: "<=0.4.0",
    valueFreekioskUnlockUnavailable: "—",
    editNotesTitle: "Notas",
    notesPlaceholder: "Añadir una nota…",
    fieldLastTelemetryReport: "Última telemetría recibida",
    sectionTelemetryData: "Datos de telemetría",
    sectionTelemetryDeviceStatus: "Estado del dispositivo (FreeKiosk)",
    sectionTelemetryGpsLocation: "Ubicación (GPS del dispositivo)",
    valueTelemetryNever: "Nunca",
    valueTelemetryEmpty: "Sin datos por ahora",
    fieldHouse: "Estructura",
    valueUnbound: "Sin vincular",
    valueNotPaired: "Sin vincular",
    valueUnassigned: "Sin asignar",
    menuRegenerateCredentials: "Regenerar credenciales",
    menuRevokeDevice: "Revocar credenciales",
    menuReactivateDevice: "Reactivar credenciales",
    menuNotes: "Notas",
    menuOtherInfo: "Más información",
    renameDeviceTitle: "Editar nombre visible",
    displayNamePlaceholder: "Nombre visible",
    displayNameEmpty: "El nombre visible no puede estar vacío",
    editGoogleAccountTitle: "Editar cuenta Google",
    telemetryBattery: "Batería",
    telemetryWifi: "Señal WiFi",
    telemetryAudio: "Volumen de audio",
    telemetryStorage: "Almacenamiento usado",
    telemetryMemory: "RAM usada",
    telemetryUnavailable: "-",
    telemetryDataAge: "Datos de {{age}}",
  },
  createModal: {
    titleCreate: "Crear nuevo dispositivo",
    titleCreated: "¡Dispositivo creado!",
    hardwareIdLabel: "ID de hardware (S/N o IMEI)",
    hardwareIdPlaceholder: "p. ej. 359881234567890",
    hardwareIdRequired: "Introduce un ID de hardware (S/N o IMEI)",
    googleAccountLabel: "Cuenta de Google",
    googleAccountPlaceholder: "p. ej. tablet@empresa.com",
    googleAccountRequired: "Introduce el email de la cuenta de Google",
    displayNameLabel: "Nombre visible (opcional)",
    displayNamePlaceholder: "p. ej. Tablet recepción",
    presetSelectorTitle: "Elige una plantilla de dispositivo",
    presetsEmpty:
      "No hay plantillas. Puedes crear una desde la página de plantillas de dispositivo o usar el modo manual abajo.",
    presetCardSpecs: 'Android {{version}} • {{resolution}} • {{inches}}"',
    presetRequired:
      "Selecciona una plantilla de dispositivo o pasa al modo manual",
    manualToggle: "Introducir los datos del hardware manualmente",
    brandPlaceholder: "p. ej. Samsung",
    androidVersionLabel: "Versión de Android",
    androidVersionPlaceholder: "p. ej. 14",
    resolutionLabel: "Resolución de pantalla",
    resolutionPlaceholder: "p. ej. 1920x1200",
    inchesLabel: "Pulgadas de pantalla",
    inchesPlaceholder: "p. ej. 10.1",
    inchesInvalid: "Las pulgadas deben ser un número válido",
    submit: "Crear dispositivo",
    successTitle: "¡Dispositivo creado correctamente!",
    successDescription:
      "Usa estas credenciales para iniciar sesión desde la tablet. No volverán a mostrarse.",
    deviceNameLabel: "Nombre del dispositivo",
    modelLabel: "Modelo",
    modelPlaceholder: "p. ej. Tab A9",
    kioskCodeLabel: "Código de dispositivo",
    passwordLabel: "Contraseña",
    qrHelp:
      "Escanea este QR desde la pantalla de inicio de sesión de la tablet para rellenar las credenciales automáticamente.",
    importantLabel: "Importante:",
    importantDescription:
      "Guarda estas credenciales ahora. Cualquiera que escanee el QR podrá iniciar sesión hasta que regeneres la contraseña.",
  },
  presets: {
    validationRequired: "Todos los campos son obligatorios",
    validationDisplayInches:
      "Las pulgadas de pantalla deben ser un número válido mayor que cero",
    created: "Plantilla creada",
    updated: "Plantilla actualizada",
    deleted: "Plantilla eliminada",
    deleteConfirm: "¿Eliminar la plantilla «{{name}}»?",
    brandPlaceholder: "Marca (p. ej. TCL)",
    modelPlaceholder: "Modelo (p. ej. TAB 10L)",
    androidVersionPlaceholder: "Versión de Android (p. ej. 15)",
    resolutionPlaceholder: "Resolución (p. ej. 800x1280)",
    inchesPlaceholder: "Pulgadas (p. ej. 10.1)",
    save: "Guardar plantilla",
    add: "Añadir plantilla",
    colModel: "Modelo",
    colAndroid: "Android",
    colResolution: "Resolución",
    colInches: "Pulgadas",
    inchesValue: "{{inches}}″",
    colActions: "Acciones",
    empty: "Aún no hay plantillas.",
    editTitle: "Editar plantilla",
    deleteTitle: "Eliminar plantilla",
  },
} as const;
